import { ProductConfigDto, ProductConfigModel } from "@husky-hrc/Framework/Types/ApiModel";
import { getRFQReason, isRFQ, parseSteps } from "@husky-hrc/Utilities/TactonUtilities";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

export interface MapApiResultParameter {
    productConfigDto: ProductConfigDto;
}

type Parameter = MapApiResultParameter & HasOnSuccess<ProductConfigModel>;
type Props = {
    result: ProductConfigModel;
};

type HandlerType = Handler<Parameter, Props>;

export const CreateProductConfigModel: HandlerType = props => {
    props.result = {} as ProductConfigModel;
};

export const MapDtoToModel: HandlerType = props => {
    props.result.id = props.parameter.productConfigDto.configId;
    props.result.tab = props.parameter.productConfigDto.tab;
    props.result.pricing = {
        listPrice: props.parameter.productConfigDto.pricing.summary.ListPrice,
        netPrice: props.parameter.productConfigDto.pricing.summary.NetPrice,
        quantity: props.parameter.productConfigDto.pricing.summary.Qty,
        description: props.parameter.productConfigDto.pricing.summary.descriptionColumn,
    };
    props.result.productId = props.parameter.productConfigDto.productId;
    props.result.response = props.parameter.productConfigDto.response;
    props.result.isRFQ = isRFQ(props.parameter.productConfigDto.bom);
    props.result.rfqReason = getRFQReason(props.parameter.productConfigDto.bom);
};

export const ParseJSONToModel: HandlerType = props => {
    props.result.steps = props.parameter.productConfigDto.steps
        .filter(step => step.available && step.name.toLowerCase() !== "hidden_step")
        .map(step => {
            return {
                name: step.name,
                description: step.description,
                current: step.current,
                groups: parseSteps(step),
            };
        });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.result);
};

export const chain = [CreateProductConfigModel, MapDtoToModel, ParseJSONToModel, ExecuteOnSuccessCallback];

const mapApiResult = createHandlerChainRunner(chain, "MapApiResult");
export default mapApiResult;
